import { Text } from '@mantine/core';

interface PoweredByProps {
  /**
   * `app` — Mantine karkasi (yon menyu, Login sahifasi);
   * `kiosk` — TV ekrani, ko'rinish `pages/kiosk.css` dagi `.k-powered` sinfidan olinadi.
   */
  variant?: 'app' | 'kiosk';
}

/**
 * "POWERED BY UFLEX" muhri — brend qoidasi bo'yicha panelning HAR BIR yuzida bo'lishi shart.
 *
 * Muhr KARKASGA ulanadi (AppLayout yon menyusi ostiga, Login sahifasiga, Kiosk oyoq qismiga),
 * har sahifaga qo'lda qo'shilmaydi — shu sabab matn va ko'rinish faqat shu faylda turadi.
 *
 * Ko'rinish (mobil ilova `app/src/components/ui.tsx` → `PoweredBy` bilan bir xil):
 * kichik matn, UPPERCASE, `letter-spacing: 0.16em`, xira rang; FAQAT "UFLEX" so'zi brend
 * rangida va qalin (fw 800). Logotip yoki emoji ISHLATILMAYDI.
 *
 * "Powered by" tarjima qilinmaydi — bu brend muhri, uchala tilda ham bir xil yoziladi
 * (mobil ilovada ham `poweredBy` kaliti uchala tilda 'Powered by').
 */
export function PoweredBy({ variant = 'app' }: PoweredByProps) {
  /*
   * Kiosk (TV) — mustaqil CSS tizimi (`pages/kiosk.css`): o'lchamlar ekran kengligiga
   * nisbatan (`--k-vw`) hisoblanadi va Mantine temasi u yerga ataylab kiritilmagan.
   * Shu sababli bu yerda faqat markup umumiy, ko'rinishni `.k-powered` beradi.
   */
  if (variant === 'kiosk') {
    return <div className="k-powered">Powered by <span className="k-powered-brand">UFLEX</span></div>;
  }

  return (
    <Text
      component="div"
      ta="center"
      fz={10}
      lh={1.6}
      fw={600}
      tt="uppercase"
      c="dimmed"
      py={10}
      style={{ letterSpacing: '0.16em' }}
    >
      Powered by <Text component="span" inherit fw={800} c="brand">UFLEX</Text>
    </Text>
  );
}
